import { createFileRoute } from "@tanstack/react-router";

import { AppShell } from "@/components/app/app-shell";
import { ContactDetailPanel } from "@/components/app/contact-detail-panel";

export const Route = createFileRoute("/_authenticated/contact/$contactId")({
  validateSearch: (search: Record<string, unknown>) => ({
    stop: search['stop'] === 1 || search['stop'] === "1" ? 1 : undefined,
  }),
  head: () => ({
    meta: [
      { title: "Contact detail | Warrior Volunteer" },
      {
        name: "description",
        content: "Full history, notes, and sharing settings for one outreach contact.",
      },
      { property: "og:title", content: "Contact detail | Warrior Volunteer" },
      {
        property: "og:description",
        content: "Full history, notes, and sharing settings for one outreach contact.",
      },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: ContactDetailPage,
});

function ContactDetailPage() {
  const { contactId } = Route.useParams();
  const { stop } = Route.useSearch();
  return (
    <AppShell eyebrow="Inbox" title="Contact detail">
      <ContactDetailPanel contactId={contactId} backTo="/contacts" autoStopTimer={stop === 1} />
    </AppShell>
  );
}
